// iter-107x: previous `eslint-disable react-hooks/immutability,
// react-hooks/set-state-in-effect` directive removed — those rules aren't
// defined by the installed eslint-plugin-react-hooks@5.2.0 (they were
// React-Compiler-beta rules) and the unknown-rule references were
// crashing the CRA dev-server with "Definition for rule was not found".
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { apiClient, useAuth } from "../App";
import { useAdminControls } from "../AdminMode";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Switch } from "../components/ui/switch";
// iter-126g: DOMPurify import + addHook + sanitised render all moved into
// pages/EventDetail/EventDescriptionView.jsx. Importing that component
// registers the iter-123 target=_blank/rel=noopener hook once on module
// load.
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../components/ui/dialog";
import { ScrollArea } from "../components/ui/scroll-area";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import PlayerPicker from "../components/PlayerPicker";
import RichTextEditor from "../components/RichTextEditor";
import { format } from "date-fns";
import { toast } from "sonner";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  TouchSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { 
  ArrowLeft, 
  Calendar, 
  Clock, 
  MapPin, 
  Users, 
  Music2, 
  Check, 
  X, 
  HelpCircle,
  Plus,
  Trash2,
  Edit,
  Music,
  UserPlus,
  Send,
  UserCheck,
  Mail,
  Bell,
  AlertCircle,
  Paperclip,
  Download,
  Upload,
  ExternalLink,
  FileText,
  CheckCircle,
  XCircle,
  StickyNote,
  ClipboardList,
  MessageCircle,
  Receipt,
  Coffee,
  ArrowUp,
  ArrowDown,
  ChevronLeft,
  ChevronRight,
  GripVertical,
  Pencil,
  ArrowRightLeft,
} from "lucide-react";
import { Checkbox } from "../components/ui/checkbox";
import EventSurveyCard from "../components/EventSurveyCard";
import NotifyMembersDialog from "../components/NotifyMembersDialog";
import CancelEventDialog from "../components/CancelEventDialog";

// iter-82: programme row helpers — shared shape used both inside the dnd-kit
// SortableContext (admins) and as a plain read-only row (everyone else).

// iter-124: extracted Programme row subcomponents. Saves ~205 LOC in EventDetail.
import {
  programmeTitleAndSubtitle,
  ReadOnlyProgrammeRow,
  SortableProgrammeRow,
} from "./EventDetail/ProgrammeRows";
// iter-124 (slice 2): extracted admin dep-invite edit dialog (~150 LOC).
import { EditDepInviteDialog } from "./EventDetail/EditDepInviteDialog";
import { EditEventDialog } from "./EventDetail/EditEventDialog";
import { ProgrammeDialogs } from "./EventDetail/ProgrammeDialogs";
import { InviteDepDialog } from "./EventDetail/InviteDepDialog";
import { EventDescriptionView } from "./EventDetail/EventDescriptionView";
import { MemberAttendanceCard } from "./EventDetail/MemberAttendanceCard";
import { EventAttachmentsCard } from "./EventDetail/EventAttachmentsCard";
import { YourAttendanceCard } from "./EventDetail/YourAttendanceCard";
import { CostsTab, ExpenditureDialog } from "./EventDetail/CostsTabAndDialog";


const EventDetail = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [eventData, setEventData] = useState(null);
  // iter-106: persist the active tab per-event so reload returns the user
  // to their preferred view. Reads/writes localStorage on change.
  const [activeTab, setActiveTab] = useState(() => {
    try {
      return localStorage.getItem(`event-detail-tab:${eventId}`) || "attendance";
    } catch {
      return "attendance";
    }
  });
  // iter-84: always-editable Details box with autosave on blur + saved-tick
  const [detailsDraft, setDetailsDraft] = useState("");
  const [detailsSaving, setDetailsSaving] = useState(false);
  const [detailsSavedAt, setDetailsSavedAt] = useState(null); // timestamp of last save
  const [detailsDirty, setDetailsDirty] = useState(false);
  const [musicLibrary, setMusicLibrary] = useState([]);
  const [deps, setDeps] = useState([]);
  const [sections, setSections] = useState([]);
  const [myPlayerProfile, setMyPlayerProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [addMusicOpen, setAddMusicOpen] = useState(false);
  const [inviteDepOpen, setInviteDepOpen] = useState(false);
  const [selectedMusic, setSelectedMusic] = useState("");
  // iter-33: multi-select set of music_ids picked in the Add Music dialog
  const [musicPickerSelection, setMusicPickerSelection] = useState(new Set());
  const [musicPickerSearch, setMusicPickerSearch] = useState("");
  const [addingMusic, setAddingMusic] = useState(false);
  // iter-33: interval/break placeholder state
  const [addIntervalOpen, setAddIntervalOpen] = useState(false);
  const [intervalLabel, setIntervalLabel] = useState("Interval");
  const [intervalDuration, setIntervalDuration] = useState("");
  // iter-94: TBC placeholder pieces — admin slots in a free-text title,
  // edits it later, and finally replaces it with a real piece from the library.
  const [addPlaceholderOpen, setAddPlaceholderOpen] = useState(false);
  const [placeholderTitleDraft, setPlaceholderTitleDraft] = useState("");
  const [editPlaceholderOpen, setEditPlaceholderOpen] = useState(false);
  const [editingPlaceholder, setEditingPlaceholder] = useState(null); // {id, title}
  const [replacePlaceholderOpen, setReplacePlaceholderOpen] = useState(false);
  const [replacingPlaceholderId, setReplacingPlaceholderId] = useState(null);
  const [replacePickerSearch, setReplacePickerSearch] = useState("");
  const [replacePickerSelection, setReplacePickerSelection] = useState("");
  const [replacingPlaceholder, setReplacingPlaceholder] = useState(false);
  const [reorderBusy, setReorderBusy] = useState(false);
  // iter-82: re-order dialog (number-input flow) + dnd-kit drag flow
  const [reorderOpen, setReorderOpen] = useState(false);
  const [reorderDraft, setReorderDraft] = useState([]); // [{id, title, pos}]
  const [savingReorder, setSavingReorder] = useState(false);

  // iter-82: dnd-kit sensors — pointer (mouse/desktop) is default; touch
  // requires a 220ms long-press so the user can still vertically scroll the
  // list without accidentally grabbing a row. 5px tolerance avoids
  // accidental triggers from finger tremor while pressing.
  const programmeSensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 220, tolerance: 5 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );
  const [reminderStats, setReminderStats] = useState(null);
  const [sendingReminder, setSendingReminder] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [myNote, setMyNote] = useState("");
  const [adminNotes, setAdminNotes] = useState("");
  const [savingAdminNotes, setSavingAdminNotes] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editForm, setEditForm] = useState(null);
  const [savingEdit, setSavingEdit] = useState(false);
  // iter-107n: reminder offset catalogue for the multi-select grid in the
  // event edit dialog (mirrors Events.jsx). Loaded once on mount.
  const [reminderCatalogue, setReminderCatalogue] = useState([]);
  const [sendingTestReminderDetail, setSendingTestReminderDetail] = useState(false);
  // iter-92: notify-members dialog + cancellation flow
  const [notifyOpen, setNotifyOpen] = useState(false);
  const [cancelOpen, setCancelOpen] = useState(false);
  const [depInviteData, setDepInviteData] = useState({
    dep_player_id: "",
    dep_player_ids: [], // iter-91: bulk-invite selection
    bulk: false,        // iter-91: toggle state
    section_id: "",
    message: "",
    for_player_id: "",  // iter-97d: which player's seat the dep is filling
  });

  // iter-116: admin-only edit dialog for an already-sent dep invitation.
  const [editInvite, setEditInvite] = useState({
    open: false,
    saving: false,
    invitation: null,
    dep_player_id: "",
    section_id: "",
    for_player_id: "",
    message: "",
  });

  // Finance: concert fee, dep fees, event expenditure
  const [concertFee, setConcertFee] = useState({ concert_fee: "", fee_paid: false, fee_paid_date: "" });
  const [savingConcertFee, setSavingConcertFee] = useState(false);
  const [expenditure, setExpenditure] = useState([]);
  const [financeCategories, setFinanceCategories] = useState([]);
  const [expDialog, setExpDialog] = useState({ open: false, data: null });
  const [depFees, setDepFees] = useState({});  // keyed by dep player_id

  // Chat (Phase 1 — admin opt-in event chat room)
  const [chatStatus, setChatStatus] = useState(null); // {enabled, room}
  const [enablingChat, setEnablingChat] = useState(false);

  // Event-linked invoices (Phase 2 D) — admin/treasurer only
  const [canManageInvoices, setCanManageInvoices] = useState(false);
  const [eventInvoices, setEventInvoices] = useState([]);
  const [loadingEventInvoices, setLoadingEventInvoices] = useState(false);

  const isAdmin = user?.role === "admin";
  const { showAdminControls } = useAdminControls();

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const r = await apiClient.get("/invoicing/permissions");
        setCanManageInvoices(!!r.data.can_manage_invoices);
      } catch {
        setCanManageInvoices(false);
      }
    })();
  }, [user?.id, user?.band_id]);

  useEffect(() => {
    if (!canManageInvoices || !eventId) return;
    (async () => {
      setLoadingEventInvoices(true);
      try {
        const r = await apiClient.get(`/invoices?event_id=${eventId}`);
        setEventInvoices(r.data || []);
      } catch {
        setEventInvoices([]);
      } finally {
        setLoadingEventInvoices(false);
      }
    })();
  }, [canManageInvoices, eventId]);

  const handleInvoiceThisBooker = () => {
    const event = eventData?.event;
    if (!event) return;
    // Event date lives on start_time (ISO datetime). `date` is rarely populated
    // — fall back chain: start_time -> arrival_time -> end_time -> today.
    const eventDateStr = event.start_time || event.arrival_time || event.end_time || event.date;
    const evDate = eventDateStr ? new Date(eventDateStr) : new Date();
    const nice = format(evDate, "d MMM yyyy");
    const desc = `${
      event.event_type === "concert" ? "Performance"
        : event.event_type === "contest" ? "Contest"
        : "Booking"
    } — ${event.title} (${nice})`;
    const lineUnit = event.concert_fee != null ? Number(event.concert_fee) : 0;
    const params = new URLSearchParams({
      open: "new",
      event_id: eventId,
      desc,
      line_desc: desc,
    });
    if (lineUnit > 0) params.set("line_unit", String(lineUnit));
    navigate(`/invoices?${params.toString()}`);
  };

  const invoiceStatusPill = (status) => {
    const styles = {
      draft: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30",
      sent: "bg-blue-500/15 text-blue-300 border-blue-500/30",
      part_paid: "bg-amber-500/15 text-amber-300 border-amber-500/30",
      paid: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
      overdue: "bg-red-500/15 text-red-300 border-red-500/30",
      cancelled: "bg-zinc-700/40 text-zinc-400 border-zinc-700",
    };
    return styles[status] || styles.draft;
  };

  // Generate Google Maps link for location
  const getMapLink = (location) => {
    if (!location) return null;
    const encodedLocation = encodeURIComponent(location);
    return `https://www.google.com/maps/search/?api=1&query=${encodedLocation}`;
  };

  // Handle file upload
  const handleFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Check file size (50MB limit)
    if (file.size > 50 * 1024 * 1024) {
      toast.error("File too large. Maximum size is 50MB.");
      return;
    }

    setUploadingFile(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      await apiClient.post(`/events/${eventId}/attachments`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      toast.success("File uploaded successfully!");
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to upload file");
    } finally {
      setUploadingFile(false);
      e.target.value = ""; // Reset input
    }
  };

  // Handle attachment download
  const handleDownloadAttachment = async (attachment) => {
    try {
      const response = await apiClient.get(
        `/events/${eventId}/attachments/${attachment.id}`,
        { responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", attachment.original_filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error("Failed to download file");
    }
  };

  // Handle attachment delete
  const handleDeleteAttachment = async (attachmentId) => {
    if (!confirm("Are you sure you want to delete this attachment?")) return;
    
    try {
      await apiClient.delete(`/events/${eventId}/attachments/${attachmentId}`);
      toast.success("Attachment deleted");
      fetchEventDetails();
    } catch (error) {
      toast.error("Failed to delete attachment");
    }
  };

  // Format file size
  const formatFileSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  // Format attendance response time (relative)
  const formatAttendanceTime = (iso) => {
    if (!iso) return "";
    try {
      const d = new Date(iso);
      const diffMs = Date.now() - d.getTime();
      const mins = Math.floor(diffMs / 60000);
      if (mins < 1) return "just now";
      if (mins < 60) return `${mins}m ago`;
      const hours = Math.floor(mins / 60);
      if (hours < 24) return `${hours}h ago`;
      const days = Math.floor(hours / 24);
      if (days < 7) return `${days}d ago`;
      return d.toLocaleDateString();
    } catch {
      return "";
    }
  };

  // Short "DD Mmm" format for the dedicated Responded column (e.g. "21 Apr").
  const formatRespondedDate = (iso) => {
    if (!iso) return "—";
    try {
      const d = new Date(iso);
      if (Number.isNaN(d.getTime())) return "—";
      const day = d.getDate();
      const month = d.toLocaleString("en-GB", { month: "short" });
      return `${day} ${month}`;
    } catch {
      return "—";
    }
  };

  // Get status badge styling
  const getStatusBadge = (status) => {
    switch (status) {
      case 'provisional':
        return <Badge className="bg-yellow-500/20 text-yellow-400 border-yellow-500/30"><AlertCircle className="w-3 h-3 mr-1" />Provisional</Badge>;
      case 'cancelled':
        return <Badge className="bg-red-500/20 text-red-400 border-red-500/30"><XCircle className="w-3 h-3 mr-1" />Cancelled</Badge>;
      case 'confirmed':
      default:
        return <Badge className="bg-green-500/20 text-green-400 border-green-500/30"><CheckCircle className="w-3 h-3 mr-1" />Confirmed</Badge>;
    }
  };

  // iter-65: prev/next event navigation so admins can step through a season
  // without going back to the list.
  const [siblingEvents, setSiblingEvents] = useState({ prev: null, next: null });
  const fetchSiblings = async () => {
    try {
      const res = await apiClient.get("/events?time_filter=all");
      const list = (res.data || []).slice().sort(
        (a, b) => (a.start_time || "").localeCompare(b.start_time || "")
      );
      const idx = list.findIndex((e) => e.id === eventId);
      if (idx < 0) return setSiblingEvents({ prev: null, next: null });
      setSiblingEvents({
        prev: idx > 0 ? list[idx - 1] : null,
        next: idx < list.length - 1 ? list[idx + 1] : null,
      });
    } catch {
      setSiblingEvents({ prev: null, next: null });
    }
  };

  useEffect(() => {
    fetchEventDetails();
    fetchMusicLibrary();
    fetchDeps();
    fetchSections();
    fetchMyProfile();
    fetchEventChatStatus();
    fetchSiblings();
    if (showAdminControls) {
      fetchReminderStats();
      fetchExpenditureAndCategories();
    }
  }, [eventId, showAdminControls]);

  // iter-107n: fetch the reminder catalogue once so admins editing this
  // event can pick multiple offsets via the same grid used on the
  // Events list dialog.
  useEffect(() => {
    if (!showAdminControls) return;
    apiClient
      .get("/events/reminder-offsets")
      .then((res) => setReminderCatalogue(res.data?.options || []))
      .catch(() => {});
  }, [showAdminControls]);

  const fetchEventChatStatus = async () => {
    try {
      const res = await apiClient.get(`/chat/events/${eventId}`);
      setChatStatus(res.data);
    } catch (e) {
      // Non-critical: chat may be disabled at the band level. Log for
      // debugging but don't toast — the UI gracefully hides if status null.
      console.error("fetchEventChatStatus failed:", e);
    }
  };

  const enableEventChat = async () => {
    setEnablingChat(true);
    try {
      const res = await apiClient.post(`/chat/events/${eventId}/enable`);
      setChatStatus({ enabled: true, room: res.data });
      toast.success("Event chat enabled");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to enable chat");
    } finally {
      setEnablingChat(false);
    }
  };

  // Keep the note textarea in sync with the loaded attendance note
  useEffect(() => {
    if (!eventData || !myPlayerProfile) return;
    const att = (eventData.attendance || []).find(a => a.player_id === myPlayerProfile.id);
    if (att) {
      setMyNote(att.notes || "");
    }
  }, [eventData, myPlayerProfile]);

  // Keep admin_notes textarea in sync with loaded event
  useEffect(() => {
    if (eventData?.event) {
      setAdminNotes(eventData.event.admin_notes || "");
      setConcertFee({
        concert_fee: eventData.event.concert_fee ?? "",
        fee_paid: !!eventData.event.fee_paid,
        fee_paid_date: eventData.event.fee_paid_date || "",
      });
    }
  }, [eventData?.event?.id, eventData?.event?.admin_notes, eventData?.event?.concert_fee, eventData?.event?.fee_paid]);

  // Keep dep-fee state in sync with attendance records for deps
  useEffect(() => {
    if (!eventData) return;
    const next = {};
    (eventData.attendance || []).forEach((a) => {
      if (a.dep_fee_amount != null || a.dep_fee_paid) {
        next[a.player_id] = {
          dep_fee_amount: a.dep_fee_amount ?? "",
          dep_fee_paid: !!a.dep_fee_paid,
          dep_fee_paid_date: a.dep_fee_paid_date || "",
        };
      }
    });
    setDepFees(next);
  }, [eventData]);

  const fetchEventDetails = async () => {
    try {
      const res = await apiClient.get(`/events/${eventId}/details`);
      setEventData(res.data);
      // iter-84: hydrate the details draft only on first load (don't clobber
      // unsaved local edits if a refetch happens mid-typing)
      setDetailsDraft((prev) =>
        prev === "" && !detailsDirty ? (res.data?.event?.description || "") : prev,
      );
    } catch (error) {
      toast.error("Failed to load event details");
      navigate("/events");
    } finally {
      setLoading(false);
    }
  };

  // iter-84: autosave the Details box when the editor loses focus
  const handleDetailsBlur = async () => {
    if (!detailsDirty) return;
    const original = eventData?.event?.description || "";
    if (detailsDraft === original) {
      setDetailsDirty(false);
      return;
    }
    setDetailsSaving(true);
    try {
      await apiClient.put(`/events/${eventId}`, { description: detailsDraft });
      setEventData((prev) =>
        prev ? { ...prev, event: { ...prev.event, description: detailsDraft } } : prev,
      );
      setDetailsDirty(false);
      setDetailsSavedAt(Date.now());
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save details");
    } finally {
      setDetailsSaving(false);
    }
  };

  const fetchMusicLibrary = async () => {
    try {
      const res = await apiClient.get("/music");
      setMusicLibrary(res.data);
    } catch (error) {
      console.error("Failed to load music library");
    }
  };

  const fetchDeps = async () => {
    try {
      const res = await apiClient.get("/deps");
      setDeps(res.data);
    } catch (error) {
      console.error("Failed to load deps");
    }
  };

  const fetchSections = async () => {
    try {
      const res = await apiClient.get("/sections");
      setSections(res.data);
    } catch (error) {
      console.error("Failed to load sections");
    }
  };

  const fetchMyProfile = async () => {
    try {
      const res = await apiClient.get("/my-player-profile");
      setMyPlayerProfile(res.data);
    } catch (error) {
      console.error("Failed to load player profile");
    }
  };

  const fetchReminderStats = async () => {
    try {
      const res = await apiClient.get(`/events/${eventId}/reminder-stats`);
      setReminderStats(res.data);
    } catch (error) {
      console.error("Failed to load reminder stats");
    }
  };

  const [reminderMessage, setReminderMessage] = useState("");
  const [reminderMessageOpen, setReminderMessageOpen] = useState(false);
  const [pendingReminderType, setPendingReminderType] = useState(null);
  // iter-83: email preview before sending
  const [reminderPreviewOpen, setReminderPreviewOpen] = useState(false);
  const [reminderPreviewLoading, setReminderPreviewLoading] = useState(false);
  const [reminderPreview, setReminderPreview] = useState(null);

  const handlePreviewReminder = async () => {
    if (!pendingReminderType) return;
    setReminderPreviewLoading(true);
    try {
      const res = await apiClient.get(`/events/${eventId}/reminder-preview`, {
        params: {
          reminder_type: pendingReminderType,
          custom_message: reminderMessage ? reminderMessage.trim() : undefined,
        },
      });
      setReminderPreview(res.data);
      setReminderPreviewOpen(true);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to load preview");
    } finally {
      setReminderPreviewLoading(false);
    }
  };

  const handleSendReminder = async (reminderType, customMessage = "") => {
    setSendingReminder(true);
    try {
      const res = await apiClient.post(`/events/${eventId}/send-reminder`, {
        reminder_type: reminderType,
        custom_message: customMessage ? customMessage.trim() : null,
      });
      const emailCount = res.data.email_count || 0;
      const pushCount = res.data.push_count || 0;
      toast.success(`Sent ${emailCount} emails and ${pushCount} push notifications!`);
      fetchReminderStats();
      setReminderMessageOpen(false);
      setReminderMessage("");
      setPendingReminderType(null);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to send reminders");
    } finally {
      setSendingReminder(false);
    }
  };

  const openReminderDialog = (reminderType) => {
    setPendingReminderType(reminderType);
    setReminderMessage("");
    setReminderMessageOpen(true);
  };

  // iter-139: printable set list (spares listed at the bottom)
  const handleDownloadProgrammePdf = async () => {
    try {
      const response = await apiClient.get(
        `/reports/events/${eventId}/programme.pdf`,
        { responseType: "blob" }
      );
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `setlist-${(event?.title || "event").replace(/\s+/g, "_")}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Set list PDF downloaded");
    } catch (error) {
      toast.error("Failed to download set list PDF");
    }
  };

  const handleDownloadAttendancePdf = async () => {
    try {
      const response = await apiClient.get(
        `/reports/events/${eventId}/attendance.pdf`,
        { responseType: "blob" }
      );
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `attendance-${(event?.title || "event").replace(/\s+/g, "_")}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Attendance PDF downloaded");
    } catch (error) {
      toast.error("Failed to download PDF");
    }
  };

  const handleDownloadAttendanceExcel = async () => {
    try {
      const response = await apiClient.get(
        `/reports/events/${eventId}/attendance.xlsx`,
        { responseType: "blob" }
      );
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `attendance-${(event?.title || "event").replace(/\s+/g, "_")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Attendance Excel downloaded");
    } catch (error) {
      toast.error("Failed to download Excel");
    }
  };

  // ============ Finance: concert fee, dep fees, event expenditure ============
  const fetchExpenditureAndCategories = async () => {
    try {
      const [exp, cats] = await Promise.all([
        apiClient.get(`/events/${eventId}/expenditure`),
        apiClient.get(`/finance/categories`),
      ]);
      setExpenditure(exp.data);
      setFinanceCategories(cats.data);
    } catch (e) {
      // Non-critical: admin-only finance section. Log for debugging.
      console.error("fetchExpenditure failed:", e);
    }
  };

  const handleSaveConcertFee = async () => {
    setSavingConcertFee(true);
    try {
      await apiClient.put(`/events/${eventId}`, {
        concert_fee: concertFee.concert_fee !== "" ? parseFloat(concertFee.concert_fee) : null,
        fee_paid: concertFee.fee_paid,
        fee_paid_date: concertFee.fee_paid_date || null,
      });
      toast.success("Concert fee saved" + (concertFee.fee_paid ? " & posted to Finance" : ""));
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to save");
    } finally {
      setSavingConcertFee(false);
    }
  };

  const handleSaveDepFee = async (playerId) => {
    const fee = depFees[playerId] || {};
    try {
      await apiClient.put(`/attendance/${eventId}/${playerId}/dep-fee`, {
        dep_fee_amount: fee.dep_fee_amount !== "" && fee.dep_fee_amount != null ? parseFloat(fee.dep_fee_amount) : null,
        dep_fee_paid: !!fee.dep_fee_paid,
        dep_fee_paid_date: fee.dep_fee_paid_date || null,
      });
      toast.success("Dep fee saved" + (fee.dep_fee_paid ? " & posted to Finance" : ""));
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to save");
    }
  };

  const handleSaveExpenditure = async () => {
    const d = expDialog.data;
    if (!d?.category_id || !d?.amount || !d?.description) {
      toast.error("Category, amount & description required");
      return;
    }
    try {
      const payload = {
        category_id: d.category_id,
        amount: parseFloat(d.amount),
        description: d.description,
        date: d.date || new Date().toISOString().slice(0, 10),
        paid: d.paid ?? true,
        paid_date: d.paid_date || null,
        notes: d.notes || null,
      };
      if (d.id) {
        await apiClient.put(`/events/${eventId}/expenditure/${d.id}`, payload);
      } else {
        await apiClient.post(`/events/${eventId}/expenditure`, payload);
      }
      toast.success("Expenditure saved");
      setExpDialog({ open: false, data: null });
      fetchExpenditureAndCategories();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed");
    }
  };

  const handleDeleteExpenditure = async (id) => {
    if (!window.confirm("Delete this expenditure?")) return;
    try {
      await apiClient.delete(`/events/${eventId}/expenditure/${id}`);
      toast.success("Deleted");
      fetchExpenditureAndCategories();
    } catch (e) { toast.error("Failed"); }
  };

  const handleMyAttendanceChange = async (status) => {
    try {
      const params = new URLSearchParams({ status });
      if (myNote !== null && myNote !== undefined) {
        params.append("notes", myNote || "");
      }
      await apiClient.put(`/my-attendance/${eventId}?${params.toString()}`);
      toast.success("Your attendance has been updated");
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update attendance");
    }
  };

  const handleSaveMyNote = async () => {
    try {
      const params = new URLSearchParams();
      const currentStatus = myAttendance?.status || "pending";
      params.append("status", currentStatus);
      params.append("notes", myNote || "");
      await apiClient.put(`/my-attendance/${eventId}?${params.toString()}`);
      toast.success("Note saved");
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to save note");
    }
  };

  const handleAttendanceChange = async (playerId, status) => {
    try {
      await apiClient.post("/attendance", {
        event_id: eventId,
        player_id: playerId,
        status
      });
      toast.success("Attendance updated");
      fetchEventDetails();
    } catch (error) {
      toast.error("Failed to update attendance");
    }
  };

  // iter-97c: admin override of a dep invitation's accept/decline state
  // without going through the dep's magic-link UI. Used inline on the
  // Deps tab so an admin can mark a dep as accepted/declined on their
  // behalf (e.g. confirmed by phone).
  const handleAdminDepStatusChange = async (invitationId, status) => {
    try {
      await apiClient.put(
        `/dep-invitations/${invitationId}?status=${encodeURIComponent(status)}`
      );
      toast.success("Dep status updated");
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update dep status");
    }
  };

  // iter-97e: admin re-assigns which player's seat a dep is covering.
  // Used inline on the Deps tab.
  const handleAdminDepForPlayerChange = async (invitationId, forPlayerId) => {
    try {
      const qs = forPlayerId
        ? `?for_player_id=${encodeURIComponent(forPlayerId)}`
        : "";
      // Send empty for_player_id as a literal empty string so the backend
      // can clear the override (falling back to the inviter). FastAPI maps
      // empty string to None for Optional[str] query params.
      await apiClient.put(`/dep-invitations/${invitationId}${qs}`);
      toast.success("Replacing player updated");
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to reassign dep");
    }
  };

  const handleAddMusic = async () => {
    const ids = Array.from(musicPickerSelection);
    if (ids.length === 0) {
      toast.error("Pick at least one piece to add");
      return;
    }
    setAddingMusic(true);
    try {
      const res = await apiClient.post(`/events/${eventId}/programme/batch`, {
        music_ids: ids,
      });
      const added = (res.data?.added || []).length;
      const skipped = (res.data?.skipped || []).length;
      if (added > 0) {
        toast.success(
          `Added ${added} piece${added === 1 ? "" : "s"} to the programme`
            + (skipped ? ` (${skipped} already on the list)` : "")
        );
      } else if (skipped > 0) {
        toast.info("Those pieces are already on the programme");
      }
      setAddMusicOpen(false);
      setMusicPickerSelection(new Set());
      setMusicPickerSearch("");
      setSelectedMusic("");
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to add music");
    } finally {
      setAddingMusic(false);
    }
  };

  const handleAddInterval = async () => {
    const label = (intervalLabel || "").trim() || "Interval";
    const duration = intervalDuration ? parseInt(intervalDuration, 10) : null;
    try {
      await apiClient.post(`/events/${eventId}/programme/interval`, {
        label,
        duration_min: duration && duration > 0 ? duration : null,
      });
      toast.success(`"${label}" added to the programme`);
      setAddIntervalOpen(false);
      setIntervalLabel("Interval");
      setIntervalDuration("");
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to add interval");
    }
  };

  // iter-94: add a TBC placeholder piece
  const handleAddPlaceholder = async () => {
    const title = (placeholderTitleDraft || "").trim();
    if (!title) {
      toast.error("Please enter a title (e.g. \"Cornet Solo - TBC\")");
      return;
    }
    try {
      await apiClient.post(`/events/${eventId}/programme/placeholder`, { title });
      toast.success(`"${title}" added to the programme`);
      setAddPlaceholderOpen(false);
      setPlaceholderTitleDraft("");
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to add placeholder");
    }
  };

  const openEditPlaceholder = (item) => {
    setEditingPlaceholder({
      id: item.id,
      title: item.placeholder_title || item.music_title || "",
    });
    setEditPlaceholderOpen(true);
  };

  const handleUpdatePlaceholder = async () => {
    if (!editingPlaceholder) return;
    const title = (editingPlaceholder.title || "").trim();
    if (!title) {
      toast.error("Title can't be empty");
      return;
    }
    try {
      await apiClient.put(
        `/events/${eventId}/programme/placeholder/${editingPlaceholder.id}`,
        { title },
      );
      toast.success("Placeholder updated");
      setEditPlaceholderOpen(false);
      setEditingPlaceholder(null);
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update placeholder");
    }
  };

  const openReplacePlaceholder = (item) => {
    setReplacingPlaceholderId(item.id);
    setReplacePickerSelection("");
    setReplacePickerSearch("");
    setReplacePlaceholderOpen(true);
  };

  const handleConfirmReplacePlaceholder = async () => {
    if (!replacingPlaceholderId || !replacePickerSelection) {
      toast.error("Pick a piece first");
      return;
    }
    setReplacingPlaceholder(true);
    try {
      await apiClient.post(
        `/events/${eventId}/programme/placeholder/${replacingPlaceholderId}/replace`,
        { music_id: replacePickerSelection },
      );
      toast.success("Placeholder replaced with piece");
      setReplacePlaceholderOpen(false);
      setReplacingPlaceholderId(null);
      setReplacePickerSelection("");
      setReplacePickerSearch("");
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to replace placeholder");
    } finally {
      setReplacingPlaceholder(false);
    }
  };

  const handleRemoveProgrammeEntry = async (entryId) => {
    try {
      await apiClient.delete(`/events/${eventId}/programme/${entryId}`);
      toast.success("Removed from programme");
      fetchEventDetails();
    } catch (error) {
      toast.error("Failed to remove entry");
    }
  };

  // iter-138: mark a set-list piece as a spare (held in reserve, excluded
  // from the running order total).
  const handleToggleSpare = async (item) => {
    try {
      const next = !item.is_spare;
      await apiClient.patch(`/events/${eventId}/programme/${item.id}/spare`, {
        is_spare: next,
      });
      toast.success(next ? "Marked as spare" : "Back in the main set list");
      fetchEventDetails();
    } catch (error) {
      toast.error("Failed to update spare flag");
    }
  };

  // Legacy handler kept as a thin wrapper so existing call sites still work
  const handleRemoveMusic = async (musicId) => {
    try {
      await apiClient.delete(`/events/${eventId}/music/${musicId}`);
      toast.success("Music removed from event");
      fetchEventDetails();
    } catch (error) {
      toast.error("Failed to remove music");
    }
  };

  const handleMoveProgrammeEntry = async (index, direction) => {
    if (reorderBusy) return;
    const list = (eventData?.repertoire || []).slice();
    const target = direction === "up" ? index - 1 : index + 1;
    if (target < 0 || target >= list.length) return;
    const orderedIds = list.map((r) => r.id);
    [orderedIds[index], orderedIds[target]] = [orderedIds[target], orderedIds[index]];
    persistOrder(orderedIds);
  };

  // iter-82: shared persist-order helper used by arrows, dnd-kit, and the
  // number-input re-order dialog. Takes the new array of entry ids in the
  // order they should appear and PUTs to the backend.
  const persistOrder = async (orderedIds) => {
    setReorderBusy(true);
    try {
      await apiClient.put(`/events/${eventId}/programme/reorder`, {
        ordered_entry_ids: orderedIds,
      });
      fetchEventDetails();
    } catch (e) {
      toast.error("Failed to reorder");
    } finally {
      setReorderBusy(false);
    }
  };

  // iter-82: dnd-kit drag end → compute new order + persist
  const handleDndEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    const list = eventData?.repertoire || [];
    const fromIdx = list.findIndex((r) => r.id === active.id);
    const toIdx = list.findIndex((r) => r.id === over.id);
    if (fromIdx === -1 || toIdx === -1) return;
    const orderedIds = list.map((r) => r.id);
    const [moved] = orderedIds.splice(fromIdx, 1);
    orderedIds.splice(toIdx, 0, moved);
    persistOrder(orderedIds);
  };

  // iter-82: open the number-input re-order dialog with current positions
  const openReorderDialog = () => {
    const list = eventData?.repertoire || [];
    setReorderDraft(
      list.map((r, idx) => {
        const isInterval = r.kind === "interval";
        const title = isInterval
          ? (r.interval_label || r.music_title || "Interval")
          : (r.music_details?.title || r.music_title || "(untitled)");
        return { id: r.id, title, isInterval, pos: idx + 1 };
      })
    );
    setReorderOpen(true);
  };

  const handleSaveReorder = async () => {
    // Sort by entered position (ascending). Ties keep their original order.
    const indexed = reorderDraft.map((row, idx) => ({ ...row, _orig: idx }));
    indexed.sort((a, b) => {
      const av = Number.isFinite(parseFloat(a.pos)) ? parseFloat(a.pos) : 9999;
      const bv = Number.isFinite(parseFloat(b.pos)) ? parseFloat(b.pos) : 9999;
      if (av !== bv) return av - bv;
      return a._orig - b._orig;
    });
    const orderedIds = indexed.map((r) => r.id);
    setSavingReorder(true);
    try {
      await persistOrder(orderedIds);
      toast.success("Programme re-ordered");
      setReorderOpen(false);
    } finally {
      setSavingReorder(false);
    }
  };

  const handleInviteDep = async () => {
    // iter-91: bulk mode posts to /dep-invitations/batch when 2+ deps selected.
    const ids = depInviteData.dep_player_ids?.length
      ? depInviteData.dep_player_ids
      : (depInviteData.dep_player_id ? [depInviteData.dep_player_id] : []);
    if (ids.length === 0) {
      toast.error("Please select at least one dep to invite");
      return;
    }
    // iter-107d: section is now required and must be one of every selected
    // dep's own sections (e.g. you can't assign Jeff [Tubas/Trombones] to
    // the MD slot). Validate client-side for a snappier error message; the
    // backend re-validates.
    if (!depInviteData.section_id) {
      toast.error("Please select the section this dep will play in for this event");
      return;
    }
    const depsByIdLocal = new Map((deps || []).map((d) => [d.id, d]));
    const invalid = ids
      .map((id) => depsByIdLocal.get(id))
      .filter((d) => d && !(d.section_ids || []).includes(depInviteData.section_id));
    if (invalid.length > 0) {
      toast.error(
        `${invalid.map((d) => d.name).join(", ")} ${invalid.length === 1 ? "isn't" : "aren't"} `
        + "in that section. Pick a section they all play in."
      );
      return;
    }
    try {
      if (ids.length === 1) {
        await apiClient.post("/dep-invitations", {
          event_id: eventId,
          dep_player_id: ids[0],
          section_id: depInviteData.section_id,
          message: depInviteData.message || null,
          for_player_id: depInviteData.for_player_id || null,
        });
        toast.success("Dep invitation sent!");
      } else {
        const payload = ids.map((dep_player_id) => ({
          event_id: eventId,
          dep_player_id,
          section_id: depInviteData.section_id,
          message: depInviteData.message || null,
          for_player_id: depInviteData.for_player_id || null,
        }));
        const res = await apiClient.post("/dep-invitations/batch", payload);
        const sent = (res.data?.created || []).length;
        const failed = (res.data?.errors || []).length;
        if (failed === 0) toast.success(`Sent ${sent} dep invitations`);
        else toast.warning(`${sent} sent, ${failed} failed — see console for detail`);
      }
      setInviteDepOpen(false);
      setDepInviteData({ dep_player_id: "", dep_player_ids: [], section_id: "", message: "", for_player_id: "" });
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to send invitation");
    }
  };

  // iter-55: invite someone NEW as a dep — registers them then sends the event invite.
  const [newDepData, setNewDepData] = useState({ name: "", email: "", phone: "", message: "" });
  const [submittingNewDep, setSubmittingNewDep] = useState(false);
  const handleInviteNewDep = async () => {
    const name = newDepData.name.trim();
    const email = newDepData.email.trim();
    if (!name || !email) {
      toast.error("Name and email are required");
      return;
    }
    setSubmittingNewDep(true);
    try {
      await apiClient.post("/dep-invitations/invite-new", {
        event_id: eventId,
        name,
        email,
        phone: newDepData.phone.trim() || null,
        message: newDepData.message.trim() || null,
      });
      toast.success(`Invited ${name} as a dep and sent them the event request.`);
      setInviteDepOpen(false);
      setNewDepData({ name: "", email: "", phone: "", message: "" });
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to invite new dep");
    } finally {
      setSubmittingNewDep(false);
    }
  };

  const handleCancelDepInvitation = async (invitationId) => {
    try {
      await apiClient.delete(`/dep-invitations/${invitationId}`);
      toast.success("Invitation cancelled");
      fetchEventDetails();
    } catch (error) {
      toast.error("Failed to cancel invitation");
    }
  };

  // iter-116: open the edit modal pre-populated with the current values.
  const handleOpenEditDepInvitation = (invitation) => {
    setEditInvite({
      open: true,
      saving: false,
      invitation,
      dep_player_id: invitation.dep_player_id || "",
      section_id: invitation.section_id || "",
      for_player_id: invitation.for_player_id || "",
      message: invitation.message || "",
    });
  };

  const handleSaveEditDepInvitation = async () => {
    if (!editInvite.invitation) return;
    const inv = editInvite.invitation;
    // Build a delta-only payload — only send what actually changed.
    const payload = {};
    if (editInvite.dep_player_id && editInvite.dep_player_id !== inv.dep_player_id) {
      payload.dep_player_id = editInvite.dep_player_id;
    }
    if ((editInvite.section_id || "") !== (inv.section_id || "")) {
      payload.section_id = editInvite.section_id || null;
    }
    if ((editInvite.for_player_id || "") !== (inv.for_player_id || "")) {
      payload.for_player_id = editInvite.for_player_id || null;
    }
    if ((editInvite.message || "") !== (inv.message || "")) {
      payload.message = editInvite.message;
    }
    if (Object.keys(payload).length === 0) {
      toast.info("No changes to save");
      setEditInvite((s) => ({ ...s, open: false }));
      return;
    }
    setEditInvite((s) => ({ ...s, saving: true }));
    try {
      await apiClient.put(`/dep-invitations/${inv.id}/edit`, payload);
      const swapped = !!payload.dep_player_id;
      toast.success(
        swapped
          ? "Invitation updated and re-sent to the new dep"
          : "Invitation updated"
      );
      setEditInvite({
        open: false, saving: false, invitation: null,
        dep_player_id: "", section_id: "", for_player_id: "", message: "",
      });
      fetchEventDetails();
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Failed to update invitation");
      setEditInvite((s) => ({ ...s, saving: false }));
    }
  };

  const handleUpdateDepStatus = async (invitationId, status) => {
    try {
      await apiClient.put(`/dep-invitations/${invitationId}?status=${status}`);
      toast.success(`Invitation ${status}`);
      fetchEventDetails();
    } catch (error) {
      toast.error("Failed to update invitation");
    }
  };

  const getAttendanceStatusBadge = (status) => {
    switch (status) {
      case "attending":
        return <Badge className="bg-green-500/20 text-green-400"><Check className="w-3 h-3 mr-1" />Attending</Badge>;
      case "not_attending":
        return <Badge className="bg-red-500/20 text-red-400"><X className="w-3 h-3 mr-1" />Not Attending</Badge>;
      case "maybe":
        return <Badge className="bg-yellow-500/20 text-yellow-400"><HelpCircle className="w-3 h-3 mr-1" />Maybe</Badge>;
      default:
        return <Badge className="bg-muted text-muted-foreground">Pending</Badge>;
    }
  };

  const getDepInviteStatusBadge = (status) => {
    switch (status) {
      case "accepted":
        return <Badge className="bg-green-500/20 text-green-400"><Check className="w-3 h-3 mr-1" />Accepted</Badge>;
      case "declined":
        return <Badge className="bg-red-500/20 text-red-400"><X className="w-3 h-3 mr-1" />Declined</Badge>;
      default:
        return <Badge className="bg-yellow-500/20 text-yellow-400"><Clock className="w-3 h-3 mr-1" />Pending</Badge>;
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-pulse text-primary text-xl font-heading">Loading...</div>
      </div>
    );
  }

  if (!eventData) return null;

  const { event, attendance, attendance_stats, repertoire, dep_invitations } = eventData;

  // Get my attendance status
  const myAttendance = myPlayerProfile 
    ? attendance.find(a => a.player_id === myPlayerProfile.id)
    : null;

  // Get available music for concert programmes:
  //  - exclude pieces already on this event's programme/repertoire
  //  - iter-77: for CONCERTS, only show pieces currently marked "in pads"
  //    (the band has actually handed them out). For other event types
  //    (rehearsals etc.) keep the full library available.
  const availableMusic = musicLibrary.filter((m) => {
    if (repertoire.some((r) => r.music_id === m.id)) return false;
    if (event?.event_type === "concert" && !m.in_pads) return false;
    return true;
  });

  // Get available deps (not already invited).
  // Members can only invite deps that share at least one of their own sections;
  // admins see every dep. Enforced server-side too (see POST /dep-invitations).
  const myPlayerSections = new Set(user?.player_profile?.section_ids || []);
  const availableDeps = deps.filter((d) => {
    if (dep_invitations.some((inv) => inv.dep_player_id === d.id)) return false;
    if (showAdminControls) return true;
    const depSections = d.section_ids || [];
    return depSections.some((sid) => myPlayerSections.has(sid));
  });

  // Separate members and deps in attendance
  const memberAttendance = attendance.filter(a => a.player_type === 'member');
  const depAttendance = attendance.filter(a => a.player_type === 'dep');

  // Group an attendance/dep list by primary_section_name preserving section order.
  // Each row carries primary_section_order from the backend so this is stable.
  const groupBySection = (rows) => {
    const groups = new Map();
    for (const row of rows) {
      const key = row.primary_section_id || `__${row.primary_section_name || 'Unassigned'}`;
      if (!groups.has(key)) {
        groups.set(key, {
          section_id: row.primary_section_id,
          section_name: row.primary_section_name || 'Unassigned',
          section_order: row.primary_section_order ?? 10000,
          rows: [],
        });
      }
      groups.get(key).rows.push(row);
    }
    return Array.from(groups.values()).sort((a, b) => {
      if (a.section_order !== b.section_order) return a.section_order - b.section_order;
      return (a.section_name || '').localeCompare(b.section_name || '');
    });
  };

  // "All Attending" = members marked attending + dep invitations accepted, grouped by section.
  const attendingMembersList = memberAttendance.filter(a => a.status === 'attending');
  const acceptedDeps = dep_invitations
    .filter(inv => inv.status === 'accepted')
    .map(inv => ({
      player_id: inv.dep_player_id,
      player_name: inv.dep_name || 'Dep',
      primary_section_id: inv.primary_section_id,
      primary_section_name: inv.primary_section_name,
      primary_section_order: inv.primary_section_order,
      part_name: null,
      player_type: 'dep',
      status: 'attending',
    }));
  const allAttendingGrouped = groupBySection([...attendingMembersList, ...acceptedDeps]);
  const allAttendingCount = attendingMembersList.length + acceptedDeps.length;
  const memberGrouped = groupBySection(memberAttendance);

  // iter-127j: section lookup map + handler for per-event section
  // overrides. Lets admins/MD move a player from their primary section
  // into one of their secondary sections, just for this event.
  const sectionsById = Object.fromEntries((sections || []).map((s) => [s.id, s]));
  const handleMoveSection = async (playerId, sectionId) => {
    try {
      if (sectionId) {
        await apiClient.put(
          `/events/${eventId}/section-overrides/${playerId}`,
          { section_id: sectionId },
        );
        toast.success(`Moved to ${sectionsById[sectionId]?.name || "section"} for this event`);
      } else {
        await apiClient.delete(`/events/${eventId}/section-overrides/${playerId}`);
        toast.success("Reset to primary section for this event");
      }
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to move section");
    }
  };

  const handleSaveAdminNotes = async () => {
    setSavingAdminNotes(true);
    try {
      await apiClient.put(`/events/${eventId}`, { admin_notes: adminNotes });
      toast.success("Admin notes saved");
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to save admin notes");
    } finally {
      setSavingAdminNotes(false);
    }
  };

  const openEditDialog = () => {
    if (!event) return;
    // Prefill form from current event
    setEditForm({
      title: event.title || "",
      event_type: event.event_type || "rehearsal",
      status: event.status || "confirmed",
      location: event.location || "",
      description: event.description || "",
      start_time: event.start_time ? format(new Date(event.start_time), "yyyy-MM-dd'T'HH:mm") : "",
      end_time: event.end_time ? format(new Date(event.end_time), "yyyy-MM-dd'T'HH:mm") : "",
      arrival_time: event.arrival_time ? format(new Date(event.arrival_time), "yyyy-MM-dd'T'HH:mm") : "",
      arrival_time_tbc: !!event.arrival_time_tbc,
      start_time_tbc: !!event.start_time_tbc,
      end_time_tbc: !!event.end_time_tbc,
      reminder_enabled: !!event.reminder_enabled,
      reminder_hours: event.reminder_hours || 24,
      // iter-107n: legacy events created before the multi-offset rollout
      // have `reminder_offsets: []` but a populated `reminder_hours`.
      // Back-compat: synthesise a single-chip selection so the UI shows
      // the existing setting instead of an empty grid.
      reminder_offsets: (() => {
        const explicit = Array.isArray(event.reminder_offsets) ? event.reminder_offsets : [];
        if (explicit.length > 0) return explicit;
        if (event.reminder_enabled && event.reminder_hours) {
          const code = `${parseInt(event.reminder_hours, 10)}h`;
          // The catalogue codes use 24h / 48h / 12h / 4h / 2h / 1h.
          if (["24h", "48h", "12h", "4h", "2h", "1h"].includes(code)) return [code];
        }
        return [];
      })(),
      // iter-134j: expose is_private in the edit form so the toggle
      // reflects the stored value and edits persist correctly.
      is_private: !!event.is_private,
      // iter-159: preload the sectional invitee list so the picker
      // reflects the current invitations.
      invited_player_ids: Array.isArray(event.invited_player_ids)
        ? event.invited_player_ids
        : [],
    });
    setEditOpen(true);
  };

  const handleSaveEdit = async () => {
    if (!editForm) return;
    setSavingEdit(true);
    try {
      const payload = {
        title: editForm.title,
        event_type: editForm.event_type,
        status: editForm.status,
        location: editForm.location,
        description: editForm.description,
        start_time: editForm.start_time ? new Date(editForm.start_time).toISOString() : null,
        end_time: editForm.end_time ? new Date(editForm.end_time).toISOString() : null,
        arrival_time: editForm.arrival_time ? new Date(editForm.arrival_time).toISOString() : null,
        arrival_time_tbc: !!editForm.arrival_time_tbc,
        start_time_tbc: !!editForm.start_time_tbc,
        end_time_tbc: !!editForm.end_time_tbc,
        reminder_enabled: !!editForm.reminder_enabled,
        // iter-107n: prefer the new multi-offset array; keep `reminder_hours`
        // in the payload for back-compat with any analytics that still read
        // it (set to the first selected offset's hour count, or 24 if empty).
        reminder_offsets: Array.isArray(editForm.reminder_offsets) ? editForm.reminder_offsets : [],
        reminder_hours: parseInt(editForm.reminder_hours, 10) || 24,
        is_private: !!editForm.is_private,  // iter-134j
        // iter-159: send invited_player_ids only for sectionals so we
        // don't accidentally overwrite it on other event types.
        ...(editForm.event_type === "rehearsal_sectional"
          ? { invited_player_ids: editForm.invited_player_ids || [] }
          : {}),
      };
      await apiClient.put(`/events/${eventId}`, payload);
      toast.success("Event updated");
      setEditOpen(false);
      fetchEventDetails();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update event");
    } finally {
      setSavingEdit(false);
    }
  };

  const handleDeleteEvent = async () => {
    if (!window.confirm(`Delete "${event.title}"? This will remove the event, its attendance records, and any attachments.`)) return;
    try {
      await apiClient.delete(`/events/${eventId}`);
      toast.success("Event deleted");
      navigate("/events");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to delete event");
    }
  };

  return (
    <div className="space-y-6 animate-fade-in">
      {/* Back Button */}
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="flex items-center gap-1 flex-wrap">
          <Button 
            variant="ghost" 
            onClick={() => navigate("/events")}
            className="text-muted-foreground hover:text-foreground"
            data-testid="back-to-events-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Events
          </Button>
          {siblingEvents.prev && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate(`/events/${siblingEvents.prev.id}`)}
              className="text-muted-foreground hover:text-foreground"
              data-testid="prev-event-btn"
              title={siblingEvents.prev.title}
            >
              <ChevronLeft className="w-4 h-4 mr-1" />
              <span className="hidden sm:inline">Previous</span>
            </Button>
          )}
          {siblingEvents.next && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate(`/events/${siblingEvents.next.id}`)}
              className="text-muted-foreground hover:text-foreground"
              data-testid="next-event-btn"
              title={siblingEvents.next.title}
            >
              <span className="hidden sm:inline">Next</span>
              <ChevronRight className="w-4 h-4 ml-1" />
            </Button>
          )}
        </div>
        {showAdminControls && (
          <div className="flex items-center gap-2 flex-wrap">
            <Button
              variant="outline"
              size="sm"
              onClick={openEditDialog}
              data-testid="edit-event-detail-btn"
              className="sm:text-base sm:h-10"
            >
              <Edit className="w-4 h-4 mr-1.5 sm:mr-2" />
              Edit
            </Button>
            {event.status !== "cancelled" && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => setCancelOpen(true)}
                className="border-orange-500/30 text-orange-400 hover:bg-orange-500/10 hover:text-orange-300 sm:text-base sm:h-10"
                data-testid="cancel-event-detail-btn"
              >
                <XCircle className="w-4 h-4 mr-1.5 sm:mr-2" />
                Cancel
              </Button>
            )}
            <Button
              variant="outline"
              size="sm"
              onClick={handleDeleteEvent}
              className="border-red-500/30 text-red-400 hover:bg-red-500/10 hover:text-red-300 sm:text-base sm:h-10"
              data-testid="delete-event-detail-btn"
            >
              <Trash2 className="w-4 h-4 mr-1.5 sm:mr-2" />
              Delete
            </Button>
          </div>
        )}
      </div>

      {/* iter-92: pending-changes banner — only admins, only when there are
          tracked changes since the last notification, and not cancelled. */}
      {showAdminControls
        && event.status !== "cancelled"
        && event.pending_changes
        && Object.keys(event.pending_changes).length > 0 && (
        <div
          className="rounded-lg border border-yellow-500/40 bg-yellow-500/10 p-4 flex flex-col sm:flex-row sm:items-center gap-3"
          data-testid="pending-changes-banner"
        >
          <Bell className="w-5 h-5 text-yellow-400 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="font-semibold text-yellow-200 text-sm">
              You have unsent changes to this event
            </div>
            <div className="text-xs text-yellow-100/80 mt-0.5">
              {Object.keys(event.pending_changes).length} change{Object.keys(event.pending_changes).length === 1 ? "" : "s"} since your last notification.
              Send a single update email to keep everyone in the loop.
            </div>
          </div>
          <Button
            size="sm"
            onClick={() => setNotifyOpen(true)}
            className="bg-yellow-500 hover:bg-yellow-600 text-black"
            data-testid="open-notify-members-btn"
          >
            <Mail className="w-4 h-4 mr-1.5" />
            Notify members
          </Button>
        </div>
      )}

      {/* iter-92: cancelled banner — shown to everyone when status=cancelled */}
      {event.status === "cancelled" && (
        <div
          className="rounded-lg border border-red-500/40 bg-red-500/10 p-4 flex items-start gap-3"
          data-testid="cancelled-banner"
        >
          <XCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <div className="font-semibold text-red-200">This event has been cancelled</div>
            {event.cancellation_reason && (
              <div className="text-sm text-red-100/80 mt-1 whitespace-pre-wrap">
                {event.cancellation_reason}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Event Header */}
      <Card className="glass-card overflow-hidden">
        <div className="relative">
          <div className="spotlight absolute inset-0 pointer-events-none opacity-50" />
          <CardContent className="p-8 relative z-10">
            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-4">
                  <Badge 
                    variant="outline" 
                    className={`text-sm ${
                      event.event_type === 'concert' 
                        ? 'border-velvet-red/50 text-velvet-red bg-velvet-red/10'
                        : event.event_type === 'contest'
                        ? 'border-purple-400/50 text-purple-300 bg-purple-500/10'
                        : 'border-blue-400/50 text-blue-400 bg-blue-500/10'
                    }`}
                  >
                    {event.event_type === 'concert' ? (
                      <Music2 className="w-4 h-4 mr-1" />
                    ) : event.event_type === 'contest' ? (
                      <Music2 className="w-4 h-4 mr-1" />
                    ) : (
                      <Calendar className="w-4 h-4 mr-1" />
                    )}
                    {event.event_type}
                  </Badge>
                  {event.status && getStatusBadge(event.status)}
                </div>
                
                <h1 className={`text-2xl sm:text-3xl lg:text-4xl font-heading font-bold tracking-tight mb-4 break-words ${event.status === 'cancelled' ? 'line-through text-muted-foreground' : ''}`}>
                  {event.title}
                </h1>
                
                {/* Iter-73: event description (renamed to "Details") moved to
                    its own card between "Your Attendance" and "Member
                    Attendance" further down the page. */}
                
                <div className="flex flex-wrap gap-6 text-sm">
                  <div className="flex items-center gap-2">
                    <Calendar className="w-4 h-4 text-primary" />
                    <span>{format(new Date(event.start_time), "EEEE, MMMM d, yyyy")}</span>
                  </div>
                  {event.arrival_time && (
                    <div className="flex items-center gap-2 text-orange-400">
                      <Clock className="w-4 h-4" />
                      <span>Arrive by {format(new Date(event.arrival_time), "h:mm a")}</span>
                    </div>
                  )}
                  <div className="flex items-center gap-2">
                    <Clock className="w-4 h-4 text-primary" />
                    <span>
                      {format(new Date(event.start_time), "h:mm a")} - {format(new Date(event.end_time), "h:mm a")}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <MapPin className="w-4 h-4 text-primary" />
                    <a 
                      href={getMapLink(event.location)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-primary hover:underline flex items-center gap-1"
                      data-testid="event-location-map-link"
                    >
                      {event.location}
                      <ExternalLink className="w-3 h-3" />
                    </a>
                  </div>
                </div>
              </div>

              {/* Attendance Stats */}
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 gap-3 lg:w-56">
                <div className="p-3 rounded-lg bg-green-500/10 text-center">
                  <p className="text-2xl font-bold text-green-400">{attendance_stats.attending}</p>
                  <p className="text-xs text-muted-foreground">Attending</p>
                </div>
                <div className="p-3 rounded-lg bg-red-500/10 text-center">
                  <p className="text-2xl font-bold text-red-400">{attendance_stats.not_attending}</p>
                  <p className="text-xs text-muted-foreground">Not Attending</p>
                </div>
                <div className="p-3 rounded-lg bg-yellow-500/10 text-center">
                  <p className="text-2xl font-bold text-yellow-400">{attendance_stats.maybe}</p>
                  <p className="text-xs text-muted-foreground">Maybe</p>
                </div>
                <div className="p-3 rounded-lg bg-muted text-center">
                  <p className="text-2xl font-bold text-muted-foreground">{attendance_stats.pending}</p>
                  <p className="text-xs text-muted-foreground">Pending</p>
                </div>
                <div className="p-3 rounded-lg bg-blue-500/10 text-center col-span-2 sm:col-span-1 lg:col-span-2">
                  <p className="text-2xl font-bold text-blue-400">{attendance_stats.deps_confirmed}</p>
                  <p className="text-xs text-muted-foreground">Deps Confirmed</p>
                </div>
              </div>
            </div>
          </CardContent>
        </div>
      </Card>

      {/* Admin-only Notes (internal notes, not visible to players) */}
      {showAdminControls && (
        <Card className="glass-card border-amber-500/20" data-testid="admin-notes-card">
          <CardHeader className="border-b border-white/5 pb-4">
            <CardTitle className="font-heading text-lg flex items-center gap-2">
              <StickyNote className="w-5 h-5 text-amber-400" />
              Admin Notes
              <Badge variant="outline" className="ml-2 bg-amber-500/15 text-amber-400 border-transparent text-[10px]">
                Admins only
              </Badge>
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6 space-y-3">
            <p className="text-xs text-muted-foreground">
              Private notes for admins — things like staging plans, contact info for the promoter, or payment details. Never shown to players.
            </p>
            <Textarea
              value={adminNotes}
              onChange={(e) => setAdminNotes(e.target.value)}
              placeholder="Add any internal notes about this event..."
              rows={4}
              className="resize-none"
              data-testid="admin-notes-textarea"
            />
            <div className="flex items-center justify-between">
              <p className="text-[10px] text-muted-foreground">
                {adminNotes.length}/2000 characters
              </p>
              <Button
                onClick={handleSaveAdminNotes}
                disabled={savingAdminNotes || adminNotes === (event.admin_notes || "")}
                size="sm"
                data-testid="save-admin-notes-btn"
              >
                {savingAdminNotes ? "Saving..." : "Save Admin Notes"}
              </Button>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Concert Fee — admin only, concerts only */}
      {showAdminControls && event.event_type === "concert" && (
        <Card className="glass-card border-emerald-500/20" data-testid="concert-fee-card">
          <CardHeader className="border-b border-white/5 pb-4">
            <CardTitle className="font-heading text-lg flex items-center gap-2">
              <FileText className="w-5 h-5 text-emerald-400" />
              Concert Fee
              <Badge variant="outline" className="ml-2 bg-emerald-500/15 text-emerald-400 border-transparent text-[10px]">
                Admins only
              </Badge>
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6 space-y-3">
            <p className="text-xs text-muted-foreground">
              The performance fee for this concert. When marked as paid, an Income transaction is auto-posted to Finance → Concert Fees.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div>
                <Label>Fee Amount (£)</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={concertFee.concert_fee}
                  onChange={(e) => setConcertFee({ ...concertFee, concert_fee: e.target.value })}
                  data-testid="concert-fee-amount"
                />
              </div>
              <div>
                <Label>Paid Date</Label>
                <Input
                  type="date"
                  value={concertFee.fee_paid_date ? concertFee.fee_paid_date.slice(0, 10) : ""}
                  onChange={(e) => setConcertFee({ ...concertFee, fee_paid_date: e.target.value })}
                  data-testid="concert-fee-date"
                />
              </div>
              <div className="flex items-end gap-2">
                <label className="flex items-center gap-2 cursor-pointer py-2">
                  <input
                    type="checkbox"
                    checked={concertFee.fee_paid}
                    onChange={(e) => setConcertFee({ ...concertFee, fee_paid: e.target.checked })}
                    className="w-4 h-4 accent-emerald-500"
                    data-testid="concert-fee-paid"
                  />
                  <span className="text-sm">Fee Received</span>
                </label>
              </div>
            </div>
            <Button
              size="sm"
              onClick={handleSaveConcertFee}
              disabled={savingConcertFee}
              data-testid="save-concert-fee-btn"
            >
              {savingConcertFee ? "Saving..." : "Save Concert Fee"}
            </Button>
          </CardContent>
        </Card>
      )}

      {/* Event Invoices — admin/treasurer only (Phase 2 D) */}
      {canManageInvoices && event && (
        <Card className="glass-card border-violet-500/20" data-testid="event-invoices-card">
          <CardHeader className="border-b border-white/5 pb-4">
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <CardTitle className="font-heading text-lg flex items-center gap-2 flex-wrap min-w-0">
                <Receipt className="w-5 h-5 text-violet-400 shrink-0" />
                <span className="break-words">Invoices for this event</span>
                <Badge variant="outline" className="bg-violet-500/15 text-violet-300 border-transparent text-[10px]">
                  Admin / treasurer
                </Badge>
              </CardTitle>
              <Button
                size="sm"
                onClick={handleInvoiceThisBooker}
                data-testid="event-invoice-booker-btn"
                className="shrink-0"
              >
                <Plus className="w-4 h-4 mr-1" />
                Invoice this booker
              </Button>
            </div>
          </CardHeader>
          <CardContent className="p-6">
            {loadingEventInvoices ? (
              <p className="text-sm text-muted-foreground">Loading invoices...</p>
            ) : eventInvoices.length === 0 ? (
              <p className="text-sm text-muted-foreground">
                No invoices linked to this event yet. Click <strong>Invoice this booker</strong> to
                create one pre-filled with this event&apos;s details
                {event.concert_fee ? ` and the £${Number(event.concert_fee).toFixed(2)} concert fee` : ""}.
              </p>
            ) : (
              <div className="space-y-2">
                {eventInvoices.map((inv) => (
                  <div
                    key={inv.id}
                    className="flex items-center justify-between p-3 bg-white/[0.02] rounded-md border border-white/[0.04] hover:bg-white/[0.04] cursor-pointer"
                    onClick={() => navigate(`/invoices`)}
                    data-testid={`event-invoice-${inv.number}`}
                  >
                    <div className="flex items-center gap-3 flex-wrap">
                      <span className="font-mono text-sm font-medium">{inv.number}</span>
                      <Badge variant="outline" className={`${invoiceStatusPill(inv.status)} text-xs`}>
                        {(inv.status || "draft").replace(/_/g, " ")}
                      </Badge>
                      <span className="text-sm text-muted-foreground">{inv.recipient_name}</span>
                    </div>
                    <div className="flex items-center gap-4 text-sm">
                      <span className="text-muted-foreground">
                        Due {inv.due_date ? inv.due_date.split("-").reverse().join("/") : "—"}
                      </span>
                      <span className="font-medium">
                        £{Number(inv.total || 0).toFixed(2)}
                      </span>
                      {Number(inv.balance || 0) > 0 && inv.status !== "cancelled" && (
                        <span className="text-amber-400 text-xs">
                          £{Number(inv.balance).toFixed(2)} due
                        </span>
                      )}
                    </div>
                  </div>
                ))}
                <div className="flex justify-between items-center pt-3 border-t border-white/10 text-sm">
                  <span className="text-muted-foreground">
                    {eventInvoices.length} invoice{eventInvoices.length !== 1 ? "s" : ""}
                    {" — "}
                    <strong className="text-foreground">
                      £{eventInvoices.filter((i) => i.status !== "cancelled").reduce((s, i) => s + Number(i.total || 0), 0).toFixed(2)}
                    </strong>{" "}
                    billed,{" "}
                    <strong className="text-emerald-400">
                      £{eventInvoices.filter((i) => i.status !== "cancelled").reduce((s, i) => s + Number(i.amount_paid || 0), 0).toFixed(2)}
                    </strong>{" "}
                    paid
                    {eventInvoices.some((i) => i.status === "cancelled") && (
                      <span className="text-zinc-500">
                        {" "}(excl. {eventInvoices.filter((i) => i.status === "cancelled").length} cancelled)
                      </span>
                    )}
                  </span>
                  <Button variant="ghost" size="sm" onClick={() => navigate("/invoices")} data-testid="event-invoices-goto-btn">
                    Open Invoices
                  </Button>
                </div>
              </div>
            )}
          </CardContent>
        </Card>
      )}

      {/* Your Attendance Card — extracted to EventDetail/YourAttendanceCard.jsx in iter-126k */}
      <YourAttendanceCard
        myPlayerProfile={myPlayerProfile}
        user={user}
        myAttendance={myAttendance}
        myNote={myNote}
        setMyNote={setMyNote}
        handleMyAttendanceChange={handleMyAttendanceChange}
        handleSaveMyNote={handleSaveMyNote}
        setInviteDepOpen={setInviteDepOpen}
      />

      {/* Iter-73: Event Details card (renamed from "description") — sits
          between "Your Attendance" and "Member Attendance" per user request.
          Iter-84: admins get an always-editable rich text editor with
          autosave-on-blur; non-admins see the rendered HTML. The whole card
          is rendered even when description is empty so admins can start
          typing without first hitting an "Edit" button. */}
      {/* Details card — extracted to EventDetail/EventDescriptionView.jsx in iter-126g.
          One card, two modes: admin = RichTextEditor with autosave-on-blur,
          non-admin = DOMPurify-sanitised HTML with brand-yellow hyperlinks. */}
      <EventDescriptionView
        description={event.description}
        showAdminControls={showAdminControls}
        detailsDraft={detailsDraft}
        setDetailsDraft={setDetailsDraft}
        detailsDirty={detailsDirty}
        setDetailsDirty={setDetailsDirty}
        detailsSaving={detailsSaving}
        detailsSavedAt={detailsSavedAt}
        handleDetailsBlur={handleDetailsBlur}
      />

      {/* Admin: Event Chat toggle */}
      {showAdminControls && chatStatus && (
        <Card className="glass-card border-primary/10" data-testid="event-chat-card">
          <CardContent className="p-4 flex items-center justify-between gap-3 flex-wrap">
            <div className="flex items-center gap-3">
              <MessageCircle className="w-5 h-5 text-primary shrink-0" />
              <div>
                <p className="text-sm font-medium">
                  {chatStatus.enabled ? "Event chat is live" : "Event chat"}
                </p>
                <p className="text-xs text-muted-foreground">
                  {chatStatus.enabled
                    ? "All band members can post. Auto-archives 7 days after event date."
                    : "Turn on a dedicated chat room for this event. Auto-archives 7 days after."}
                </p>
              </div>
            </div>
            {chatStatus.enabled ? (
              <Link to={`/chat?room=${chatStatus.room.id}`}>
                <Button variant="outline" size="sm" data-testid="open-event-chat-btn">
                  Open chat
                </Button>
              </Link>
            ) : (
              <Button
                size="sm"
                onClick={enableEventChat}
                disabled={enablingChat}
                data-testid="enable-event-chat-btn"
              >
                {enablingChat ? "Enabling…" : "Enable chat"}
              </Button>
            )}
          </CardContent>
        </Card>
      )}

      {/* Admin Email Reminders Card */}
      {showAdminControls && reminderStats && (
        <Card className="glass-card border-blue-500/20">
          <CardHeader className="border-b border-white/5 pb-4">
            <div className="flex items-center gap-2">
              <Mail className="w-5 h-5 text-blue-400" />
              <CardTitle className="font-heading text-lg">Email Reminders</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Send to Attending/Maybe */}
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-green-500/10 flex items-center justify-center flex-shrink-0">
                    <Check className="w-5 h-5 text-green-400" />
                  </div>
                  <div>
                    <h4 className="font-medium">Attending & Maybe</h4>
                    <p className="text-sm text-muted-foreground">
                      {reminderStats.attending_count + reminderStats.maybe_count} players have responded Yes or Maybe
                    </p>
                  </div>
                </div>
                <Button
                  variant="outline"
                  className="w-full border-green-500/30 text-green-400 hover:bg-green-500/10"
                  onClick={() => openReminderDialog('attending')}
                  disabled={sendingReminder || (reminderStats.attending_count + reminderStats.maybe_count) === 0}
                  data-testid="send-reminder-attending-btn"
                >
                  <Bell className="w-4 h-4 mr-2" />
                  {sendingReminder ? 'Sending...' : 'Send Event Reminder'}
                </Button>
                {reminderStats.reminder_enabled && (
                  <p className="text-xs text-muted-foreground flex items-center gap-1">
                    <Bell className="w-3 h-3" />
                    Auto-reminder: {reminderStats.reminder_hours}h before event
                    {reminderStats.reminder_sent && <Badge variant="outline" className="ml-2 text-xs">Sent</Badge>}
                  </p>
                )}
              </div>

              {/* Send to Non-Responders */}
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-orange-500/10 flex items-center justify-center flex-shrink-0">
                    <AlertCircle className="w-5 h-5 text-orange-400" />
                  </div>
                  <div>
                    <h4 className="font-medium">Pending &amp; Maybe</h4>
                    <p className="text-sm text-muted-foreground">
                      {reminderStats.non_responders_count} players haven&apos;t committed yet (no response or &ldquo;Maybe&rdquo;)
                    </p>
                  </div>
                </div>
                <Button
                  variant="outline"
                  className="w-full border-orange-500/30 text-orange-400 hover:bg-orange-500/10"
                  onClick={() => openReminderDialog('non_responders')}
                  disabled={sendingReminder || reminderStats.non_responders_count === 0}
                  data-testid="send-reminder-nonresponders-btn"
                >
                  <Mail className="w-4 h-4 mr-2" />
                  {sendingReminder ? 'Sending...' : 'Nudge Non-Responders'}
                </Button>
                <p className="text-xs text-muted-foreground flex items-center gap-1">
                  <Bell className="w-3 h-3" />
                  Auto-reminder: 7 days before event
                  {reminderStats.non_responder_reminder_sent && <Badge variant="outline" className="ml-2 text-xs">Sent</Badge>}
                </p>
                <div className="flex gap-2 mt-2">
                  <Button
                    variant="outline"
                    size="sm"
                    className="flex-1 border-blue-500/30 text-blue-400 hover:bg-blue-500/10"
                    onClick={handleDownloadAttendancePdf}
                    data-testid="download-attendance-pdf-btn"
                  >
                    <Download className="w-4 h-4 mr-2" />
                    PDF
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    className="flex-1 border-emerald-500/30 text-emerald-400 hover:bg-emerald-500/10"
                    onClick={handleDownloadAttendanceExcel}
                    data-testid="download-attendance-excel-btn"
                  >
                    <Download className="w-4 h-4 mr-2" />
                    Excel
                  </Button>
                </div>
              </div>
            </div>

            {/* Summary Stats */}
            <div className="mt-6 pt-4 border-t border-white/10 grid grid-cols-4 gap-4 text-center">
              <div>
                <p className="text-lg font-bold text-green-400">{reminderStats.attending_count}</p>
                <p className="text-xs text-muted-foreground">Attending</p>
              </div>
              <div>
                <p className="text-lg font-bold text-yellow-400">{reminderStats.maybe_count}</p>
                <p className="text-xs text-muted-foreground">Maybe</p>
              </div>
              <div>
                <p className="text-lg font-bold text-red-400">{reminderStats.not_attending_count}</p>
                <p className="text-xs text-muted-foreground">Not Attending</p>
              </div>
              <div>
                <p className="text-lg font-bold text-orange-400">{reminderStats.non_responders_count}</p>
                <p className="text-xs text-muted-foreground">No Response</p>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Tabs for Attendance, Deps, and Repertoire */}
      {/* iter-106: persist active tab per-event in localStorage so reload
         returns the user to their preferred view. */}
      <Tabs
        value={activeTab}
        onValueChange={(v) => {
          setActiveTab(v);
          try { localStorage.setItem(`event-detail-tab:${eventId}`, v); } catch { /* ignore */ }
        }}
        className="w-full"
      >
        {/*
          iter-93g: the tab bar previously sat in `overflow-x-auto` with
          ``TabsList`` forced to ``w-max`` — that meant on phones/narrow
          tablets you had to swipe sideways to see Files / Survey / Costs.
          Switching to flex-wrap (h-auto so vertical stacking isn't capped
          at the default 40px TabsList height) lets every option show in
          one visible block regardless of viewport.
        */}
        <TabsList
          className="bg-secondary/50 mb-4 flex flex-wrap justify-start gap-1 h-auto p-1 w-full"
          data-testid="event-detail-tablist"
        >
          <TabsTrigger value="all-attending" className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground" data-testid="tab-all-attending">
            <UserCheck className="w-4 h-4 mr-2" />
            All ({allAttendingCount})
          </TabsTrigger>
          <TabsTrigger value="attendance" className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground">
            <Users className="w-4 h-4 mr-2" />
            Members ({memberAttendance.length})
          </TabsTrigger>
          <TabsTrigger value="deps" className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground">
            <UserPlus className="w-4 h-4 mr-2" />
            Deps ({dep_invitations.length})
          </TabsTrigger>
          <TabsTrigger value="repertoire" className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground">
            <Music className="w-4 h-4 mr-2" />
            Repertoire ({repertoire.length})
          </TabsTrigger>
          <TabsTrigger value="attachments" className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground">
            <Paperclip className="w-4 h-4 mr-2" />
            Files ({event.attachments?.length || 0})
          </TabsTrigger>
          <TabsTrigger value="survey" className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground" data-testid="tab-survey">
            <ClipboardList className="w-4 h-4 mr-2" />
            Survey
          </TabsTrigger>
          {showAdminControls && (
            <TabsTrigger value="costs" className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground" data-testid="tab-costs">
              <FileText className="w-4 h-4 mr-2" />
              Costs ({expenditure.length})
            </TabsTrigger>
          )}
        </TabsList>

        {/* All Attending Tab — combined members + accepted deps, grouped by section */}
        <TabsContent value="all-attending">
          <Card className="glass-card">
            <CardHeader className="border-b border-white/5 pb-4">
              <div className="flex items-center justify-between">
                <CardTitle className="font-heading text-lg">Confirmed Attendees</CardTitle>
                <div className="text-sm text-muted-foreground" data-testid="all-attending-count">
                  {allAttendingCount} confirmed ({attendingMembersList.length} members + {acceptedDeps.length} deps)
                </div>
              </div>
            </CardHeader>
            <CardContent className="p-0">
              <ScrollArea className="h-[500px]">
                {allAttendingGrouped.length === 0 ? (
                  <div className="p-8 text-center text-muted-foreground text-sm" data-testid="all-attending-empty">
                    No confirmed attendees yet.
                  </div>
                ) : (
                  <div className="divide-y divide-white/5">
                    {allAttendingGrouped.map((group) => (
                      <div key={group.section_id || group.section_name} data-testid={`all-attending-section-${group.section_id || group.section_name}`}>
                        {/* iter-128d: same fix as MemberAttendanceCard.jsx
                            (iter-127k). `bg-primary/[0.06]` is only 6%
                            opaque, so player names behind bled through
                            when the header stuck to the top of the
                            scroll area. Switched to a solid card-tinted
                            background + backdrop-blur so scrolled
                            content is completely obscured. */}
                        <div className="px-3 py-1.5 bg-secondary/95 supports-[backdrop-filter]:bg-secondary/80 backdrop-blur-md border-b border-t border-primary/20 flex items-center justify-between sticky top-0 z-10">
                          <h4 className="text-[10px] uppercase tracking-wider text-primary font-semibold">
                            {group.section_name}
                          </h4>
                          <span className="text-[10px] text-muted-foreground tabular-nums">
                            {group.rows.length}
                          </span>
                        </div>
                        <ul className="divide-y divide-white/[0.04]">
                          {group.rows.map((row) => (
                            <li
                              key={`${row.player_type}-${row.player_id}`}
                              className="flex items-center justify-between gap-3 px-3 py-2 hover:bg-secondary/20 transition-colors"
                              data-testid={`all-attending-row-${row.player_id}`}
                            >
                              <div className="min-w-0 flex-1">
                                <p className="text-sm font-medium truncate leading-tight">{row.player_name}</p>
                                {row.part_name && (
                                  <p className="text-[11px] text-muted-foreground leading-tight">{row.part_name}</p>
                                )}
                              </div>
                              {row.player_type === 'dep' ? (
                                <span className="text-[10px] text-blue-400/90 flex-shrink-0" title="Dep">Dep</span>
                              ) : null}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
              </ScrollArea>
            </CardContent>
          </Card>
        </TabsContent>

        {/* Attendance Tab — extracted to EventDetail/MemberAttendanceCard.jsx in iter-126j */}
        <TabsContent value="attendance">
          <MemberAttendanceCard
            memberGrouped={memberGrouped}
            attendance_stats={attendance_stats}
            showAdminControls={showAdminControls}
            handleAttendanceChange={handleAttendanceChange}
            getAttendanceStatusBadge={getAttendanceStatusBadge}
            formatRespondedDate={formatRespondedDate}
            sectionsById={sectionsById}
            handleMoveSection={handleMoveSection}
          />
        </TabsContent>

        {/* Deps Tab */}
        <TabsContent value="deps">
          <Card className="glass-card">
            <CardHeader className="border-b border-white/5 pb-4">
              <div className="flex items-center justify-between">
                <CardTitle className="font-heading text-lg">Dep Invitations</CardTitle>
                <Button
                  className="bg-primary text-primary-foreground"
                  data-testid="invite-dep-btn"
                  onClick={() => setInviteDepOpen(true)}
                >
                  <UserPlus className="w-4 h-4 mr-2" />
                  Invite Dep
                </Button>
              </div>
            </CardHeader>
            <CardContent className="p-6">
              {dep_invitations.length > 0 ? (
                <div className="space-y-4">
                  {dep_invitations.map((invitation) => (
                    <div key={invitation.id} className="rounded-lg bg-secondary/30 hover:bg-secondary/50 transition-colors min-w-0">
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-4">
                      <div className="flex items-start gap-4 min-w-0 flex-1">
                        <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center shrink-0">
                          <UserCheck className="w-5 h-5 text-blue-400" />
                        </div>
                        <div className="min-w-0 flex-1">
                          <p className="font-medium break-words">{invitation.dep_name}</p>
                          <p className="text-sm text-muted-foreground break-words">
                            {invitation.section_name || "Any section"}
                            {/* Iter-75: hide "Invited by …" for bulk-import rows
                                (legacy DB rows stamped with "Bulk import") and
                                anything with no inviter set. Real player invites
                                still show the inviter's name. */}
                            {invitation.invited_by_name && invitation.invited_by_name !== "Bulk import" && (
                              <> • Invited by {invitation.invited_by_name}</>
                            )}
                          </p>
                          {/* iter-97e: show which player this dep is replacing
                              if the invitation has an explicit attribution that
                              differs from the inviter. */}
                          {invitation.for_player_name && invitation.for_player_id !== invitation.invited_by_player_id && (
                            <p className="text-xs text-primary/80 mt-1 break-words" data-testid={`dep-replacing-${invitation.id}`}>
                              Replacing <span className="font-medium">{invitation.for_player_name}</span>
                            </p>
                          )}
                          {invitation.message && (
                            <p className="text-xs text-muted-foreground mt-1 italic break-words">&quot;{invitation.message}&quot;</p>
                          )}
                        </div>
                      </div>

                      <div className="flex flex-wrap items-center gap-2 sm:gap-3 sm:justify-end sm:shrink-0">
                        {getDepInviteStatusBadge(invitation.status)}

                        {showAdminControls && (
                          <Select
                            value={invitation.status}
                            onValueChange={(v) => handleAdminDepStatusChange(invitation.id, v)}
                          >
                            <SelectTrigger
                              className="w-28 sm:w-32 h-8 bg-secondary/50 text-xs"
                              data-testid={`admin-dep-status-${invitation.id}`}
                              title="Override the dep's response on their behalf"
                            >
                              <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="pending">Pending</SelectItem>
                              <SelectItem value="accepted">Accepted</SelectItem>
                              <SelectItem value="declined">Declined</SelectItem>
                            </SelectContent>
                          </Select>
                        )}

                        {showAdminControls && (
                          <Select
                            value={invitation.for_player_id || "__inviter"}
                            onValueChange={(v) => handleAdminDepForPlayerChange(invitation.id, v === "__inviter" ? "" : v)}
                          >
                            <SelectTrigger
                              className="w-36 sm:w-40 h-8 bg-secondary/50 text-xs"
                              data-testid={`admin-dep-for-player-${invitation.id}`}
                              title="Re-assign which player's seat this dep is filling"
                            >
                              <SelectValue placeholder="Replacing…" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="__inviter">
                                {invitation.invited_by_name ? `Inviter (${invitation.invited_by_name})` : "Inviter"}
                              </SelectItem>
                              {memberAttendance
                                .slice()
                                .sort((a, b) => (a.player_name || "").localeCompare(b.player_name || ""))
                                .map((m) => (
                                  <SelectItem key={m.player_id} value={m.player_id}>
                                    {m.player_name}
                                    {m.status === "not_attending" ? " (Can't go)" : m.status === "maybe" ? " (Maybe)" : ""}
                                  </SelectItem>
                                ))}
                            </SelectContent>
                          </Select>
                        )}
                        
                        {invitation.status === 'pending' && (
                          <Button
                            variant="ghost"
                            size="icon"
                            className="text-destructive hover:text-destructive shrink-0"
                            onClick={() => handleCancelDepInvitation(invitation.id)}
                            data-testid={`cancel-dep-${invitation.id}`}
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        )}

                        {/* iter-116: admin-only edit-invite button. Opens a
                            dialog letting an admin swap the dep, change the
                            section / replacement / message all in one go. */}
                        {showAdminControls && (
                          <Button
                            variant="ghost"
                            size="icon"
                            className="shrink-0"
                            onClick={() => handleOpenEditDepInvitation(invitation)}
                            data-testid={`edit-dep-invite-${invitation.id}`}
                            title="Edit / amend this invitation"
                          >
                            <Pencil className="w-4 h-4" />
                          </Button>
                        )}
                      </div>
                      </div>
                    {/* Admin-only dep fee row */}
                    {showAdminControls && (
                      <div className="mx-4 mb-4 p-3 rounded-lg bg-amber-500/5 border border-amber-500/20 flex flex-wrap items-end gap-3" data-testid={`dep-fee-row-${invitation.dep_player_id}`}>
                        <div className="flex-1 min-w-[120px]">
                          <Label className="text-xs text-amber-400">Fee (£)</Label>
                          <Input
                            type="number"
                            step="0.01"
                            value={depFees[invitation.dep_player_id]?.dep_fee_amount ?? ""}
                            onChange={(e) => setDepFees({
                              ...depFees,
                              [invitation.dep_player_id]: {
                                ...(depFees[invitation.dep_player_id] || {}),
                                dep_fee_amount: e.target.value,
                              },
                            })}
                            className="h-8 text-sm"
                            data-testid={`dep-fee-amount-${invitation.dep_player_id}`}
                          />
                        </div>
                        <div className="flex-1 min-w-[140px]">
                          <Label className="text-xs text-amber-400">Paid Date</Label>
                          <Input
                            type="date"
                            value={depFees[invitation.dep_player_id]?.dep_fee_paid_date?.slice(0, 10) || ""}
                            onChange={(e) => setDepFees({
                              ...depFees,
                              [invitation.dep_player_id]: {
                                ...(depFees[invitation.dep_player_id] || {}),
                                dep_fee_paid_date: e.target.value,
                              },
                            })}
                            className="h-8 text-sm"
                          />
                        </div>
                        <label className="flex items-center gap-2 py-2 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={!!depFees[invitation.dep_player_id]?.dep_fee_paid}
                            onChange={(e) => setDepFees({
                              ...depFees,
                              [invitation.dep_player_id]: {
                                ...(depFees[invitation.dep_player_id] || {}),
                                dep_fee_paid: e.target.checked,
                              },
                            })}
                            className="w-4 h-4 accent-amber-500"
                            data-testid={`dep-fee-paid-${invitation.dep_player_id}`}
                          />
                          <span className="text-xs text-amber-400">Paid</span>
                        </label>
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => handleSaveDepFee(invitation.dep_player_id)}
                          className="h-8"
                          data-testid={`save-dep-fee-${invitation.dep_player_id}`}
                        >
                          Save
                        </Button>
                      </div>
                    )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-12 text-muted-foreground">
                  <UserPlus className="w-12 h-12 mx-auto mb-4 opacity-50" />
                  <p>No deps invited yet</p>
                  <p className="text-sm mt-2">Invite deps to cover for members who can&apos;t attend</p>
                </div>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {/* Repertoire Tab */}
        <TabsContent value="repertoire">
          <Card className="glass-card">
            <CardHeader className="border-b border-white/5 pb-4">
              <div className="flex items-center justify-between">
                <CardTitle className="font-heading text-lg">
                  {event.event_type === 'concert' ? 'Concert Programme' : 'Rehearsal Music'}
                </CardTitle>
                <div className="flex items-center gap-2 flex-wrap justify-end">
                {repertoire.length > 0 && (
                  <Button
                    variant="outline"
                    className="border-blue-500/30 text-blue-400 hover:bg-blue-500/10"
                    onClick={handleDownloadProgrammePdf}
                    data-testid="download-programme-pdf-btn"
                  >
                    <Download className="w-4 h-4 mr-2" />
                    Set list PDF
                  </Button>
                )}
                {showAdminControls && (
                  <div className="flex items-center gap-2 flex-wrap justify-end">
                    {/* Re-order via number-input dialog (mobile-friendly) */}
                    {repertoire.length > 1 && (
                      <Button
                        variant="outline"
                        className="border-white/20"
                        onClick={openReorderDialog}
                        data-testid="reorder-programme-btn"
                      >
                        <ArrowUp className="w-4 h-4 mr-1" />
                        <ArrowDown className="w-4 h-4 mr-2 -ml-2" />
                        Re-order
                      </Button>
                    )}
                    {/* Add Interval — Dialog moved to ProgrammeDialogs.jsx (iter-126c) */}
                    <Button
                      variant="outline"
                      className="border-white/20"
                      data-testid="add-interval-btn"
                      onClick={() => setAddIntervalOpen(true)}
                    >
                      <Coffee className="w-4 h-4 mr-2" />
                      Interval
                    </Button>

                    {/* iter-94: Add TBC placeholder — Dialog moved to ProgrammeDialogs.jsx */}
                    <Button
                      variant="outline"
                      className="border-blue-400/30 text-blue-300 hover:bg-blue-500/10 hover:text-blue-200"
                      data-testid="add-placeholder-btn"
                      onClick={() => setAddPlaceholderOpen(true)}
                    >
                      <HelpCircle className="w-4 h-4 mr-2" />
                      TBC piece
                    </Button>

                    {/* Add Music — Dialog moved to ProgrammeDialogs.jsx */}
                    <Button
                      className="bg-primary text-primary-foreground"
                      data-testid="add-repertoire-btn"
                      onClick={() => setAddMusicOpen(true)}
                    >
                      <Plus className="w-4 h-4 mr-2" />
                      Add Music
                    </Button>
                  </div>
                )}
                </div>
              </div>
            </CardHeader>
            <CardContent className="p-6">
              {repertoire.length > 0 ? (
                <div className="space-y-3">
                  {showAdminControls ? (
                    <DndContext
                      sensors={programmeSensors}
                      collisionDetection={closestCenter}
                      onDragEnd={handleDndEnd}
                    >
                      <SortableContext
                        items={repertoire.map((r) => r.id)}
                        strategy={verticalListSortingStrategy}
                      >
                        {(() => {
                          let n = 0;
                          return repertoire.map((item, index) => {
                            const num = item.kind === "interval" || item.is_spare ? null : ++n;
                            return (
                          <SortableProgrammeRow
                            key={item.id}
                            item={item}
                            index={index}
                            displayNumber={num}
                            total={repertoire.length}
                            reorderBusy={reorderBusy}
                            onMoveUp={() => handleMoveProgrammeEntry(index, "up")}
                            onMoveDown={() => handleMoveProgrammeEntry(index, "down")}
                            onRemove={() => handleRemoveProgrammeEntry(item.id)}
                            onToggleSpare={() => handleToggleSpare(item)}
                            onEditPlaceholder={() => openEditPlaceholder(item)}
                            onReplacePlaceholder={() => openReplacePlaceholder(item)}
                          />
                            );
                          });
                        })()}
                      </SortableContext>
                    </DndContext>
                  ) : (
                    (() => {
                      let n = 0;
                      return repertoire.map((item, index) => {
                        const num = item.kind === "interval" || item.is_spare ? null : ++n;
                        return (
                          <ReadOnlyProgrammeRow key={item.id} item={item} index={index} displayNumber={num} />
                        );
                      });
                    })()
                  )}

                  {/* Total Duration — spares are excluded from the running order */}
                  {repertoire.some(r => r.music_details?.duration_minutes || r.interval_duration_min) && (
                    <div className="flex justify-end pt-4 border-t border-white/5">
                      <Badge variant="outline" className="text-sm" data-testid="programme-total-duration">
                        <Clock className="w-4 h-4 mr-2" />
                        Total: {repertoire.reduce((acc, r) => acc + (r.is_spare ? 0 : (r.music_details?.duration_minutes || r.interval_duration_min || 0)), 0)} minutes
                      </Badge>
                    </div>
                  )}
                </div>
              ) : (
                <div className="text-center py-12 text-muted-foreground">
                  <Music className="w-12 h-12 mx-auto mb-4 opacity-50" />
                  <p>No music added to this event yet</p>
                  {showAdminControls && (
                    <Button 
                      variant="outline" 
                      className="mt-4"
                      onClick={() => setAddMusicOpen(true)}
                    >
                      Add Music
                    </Button>
                  )}
                </div>
              )}
            </CardContent>
          </Card>

          {/* iter-82: Number-input re-order dialog — moved to ProgrammeDialogs.jsx (iter-126c) */}
        </TabsContent>
        <TabsContent value="attachments">
          {/* Attachments tab — extracted to EventDetail/EventAttachmentsCard.jsx in iter-126j */}
          <EventAttachmentsCard
            attachments={event.attachments}
            showAdminControls={showAdminControls}
            uploadingFile={uploadingFile}
            handleFileUpload={handleFileUpload}
            handleDownloadAttachment={handleDownloadAttachment}
            handleDeleteAttachment={handleDeleteAttachment}
            formatFileSize={formatFileSize}
          />
        </TabsContent>

        {/* Survey Tab */}
        <TabsContent value="survey">
          <EventSurveyCard
            eventId={eventId}
            showAdminControls={showAdminControls}
            eventTitle={event.title}
          />
        </TabsContent>

        {/* Costs tab — admin only */}
        {showAdminControls && (
          <TabsContent value="costs">
            {/* Costs tab — extracted to EventDetail/CostsTabAndDialog.jsx in iter-126k */}
            <CostsTab
              expenditure={expenditure}
              expDialog={expDialog}
              setExpDialog={setExpDialog}
              handleDeleteExpenditure={handleDeleteExpenditure}
            />
          </TabsContent>
        )}
      </Tabs>

      {/* Expenditure add/edit dialog — extracted to EventDetail/CostsTabAndDialog.jsx in iter-126k */}
      {showAdminControls && (
        <ExpenditureDialog
          expDialog={expDialog}
          setExpDialog={setExpDialog}
          financeCategories={financeCategories}
          handleSaveExpenditure={handleSaveExpenditure}
        />
      )}

      {/* Reminder custom-message dialog (admin) */}
      {showAdminControls && (
        <Dialog open={reminderMessageOpen} onOpenChange={(o) => { if (!o) { setReminderMessageOpen(false); setReminderMessage(""); setPendingReminderType(null); } }}>
          <DialogContent data-testid="reminder-message-dialog">
            <DialogHeader>
              <DialogTitle>
                {pendingReminderType === 'non_responders' ? 'Nudge Non-Responders' : 'Send Event Reminder'}
              </DialogTitle>
            </DialogHeader>
            <div className="space-y-3">
              <p className="text-sm text-muted-foreground">
                Add an optional personal message — it&apos;ll be highlighted at the top of the reminder email and pushed with the notification. Leave blank to send the standard reminder.
              </p>
              <Label>Custom message (optional)</Label>
              <Textarea
                rows={4}
                value={reminderMessage}
                onChange={(e) => setReminderMessage(e.target.value)}
                placeholder="e.g. Remember to bring your Christmas programme music and wear full uniform. Warm-up at 6:45pm sharp."
                data-testid="reminder-custom-message"
              />
              <p className="text-[11px] text-muted-foreground">
                {reminderMessage.length}/500 characters
              </p>
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <Button variant="outline" onClick={() => { setReminderMessageOpen(false); setReminderMessage(""); setPendingReminderType(null); }}>
                Cancel
              </Button>
              <Button
                variant="outline"
                onClick={handlePreviewReminder}
                disabled={reminderPreviewLoading || sendingReminder}
                data-testid="preview-reminder-btn"
              >
                {reminderPreviewLoading ? "Loading…" : "Preview"}
              </Button>
              <Button
                onClick={() => handleSendReminder(pendingReminderType, reminderMessage)}
                disabled={sendingReminder}
                data-testid="confirm-send-reminder-btn"
              >
                {sendingReminder ? 'Sending...' : 'Send'}
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}

      {/* iter-83: Email preview sub-dialog */}
      {showAdminControls && (
        <Dialog open={reminderPreviewOpen} onOpenChange={setReminderPreviewOpen}>
          <DialogContent className="max-w-3xl max-h-[90vh] flex flex-col" data-testid="reminder-preview-dialog">
            <DialogHeader>
              <DialogTitle>Email preview</DialogTitle>
            </DialogHeader>
            {reminderPreview && (
              <>
                <div className="text-sm text-muted-foreground space-y-1 pb-2 border-b border-white/5">
                  <p>
                    <span className="font-medium text-foreground">Subject:</span>{" "}
                    <span data-testid="preview-subject">{reminderPreview.subject}</span>
                  </p>
                  <p>
                    Will be sent to{" "}
                    <span className="font-medium text-foreground" data-testid="preview-recipient-count">
                      {reminderPreview.recipient_count}
                    </span>{" "}
                    player{reminderPreview.recipient_count === 1 ? "" : "s"}.
                    {reminderPreview.sample_recipient?.name && (
                      <> Showing render for <span className="italic">{reminderPreview.sample_recipient.name}</span>.</>
                    )}
                  </p>
                </div>
                <div
                  className="flex-1 overflow-y-auto bg-white text-black rounded-md mt-3"
                  data-testid="preview-html-frame"
                >
                  <iframe
                    title="Email preview"
                    srcDoc={reminderPreview.html}
                    className="w-full h-[60vh] rounded-md"
                    sandbox=""
                  />
                </div>
              </>
            )}
            <div className="flex justify-end gap-2 mt-4 pt-3 border-t border-white/5">
              <Button variant="outline" onClick={() => setReminderPreviewOpen(false)}>
                Close preview
              </Button>
              <Button
                onClick={() => {
                  setReminderPreviewOpen(false);
                  handleSendReminder(pendingReminderType, reminderMessage);
                }}
                disabled={sendingReminder}
                data-testid="preview-then-send-btn"
              >
                {sendingReminder ? "Sending…" : "Looks good — send now"}
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}

      {/* Edit Event Dialog (admin) — extracted to EventDetail/EditEventDialog.jsx in iter-126 */}
      {showAdminControls && (
        <EditEventDialog
          open={editOpen}
          onOpenChange={setEditOpen}
          editForm={editForm}
          setEditForm={setEditForm}
          reminderCatalogue={reminderCatalogue}
          eventId={eventId}
          sendingTestReminder={sendingTestReminderDetail}
          setSendingTestReminder={setSendingTestReminderDetail}
          saving={savingEdit}
          onSave={handleSaveEdit}
        />
      )}

      {/* Programme management dialogs — extracted to EventDetail/ProgrammeDialogs.jsx in iter-126c.
          Renders 6 dialogs: Add Interval, Add TBC placeholder, Edit TBC, Replace TBC, Add Music,
          Re-order programme. All controlled by parent state. Trigger buttons stay inline above. */}
      {showAdminControls && (
        <ProgrammeDialogs
          addIntervalOpen={addIntervalOpen}
          setAddIntervalOpen={setAddIntervalOpen}
          intervalLabel={intervalLabel}
          setIntervalLabel={setIntervalLabel}
          intervalDuration={intervalDuration}
          setIntervalDuration={setIntervalDuration}
          handleAddInterval={handleAddInterval}
          addPlaceholderOpen={addPlaceholderOpen}
          setAddPlaceholderOpen={setAddPlaceholderOpen}
          placeholderTitleDraft={placeholderTitleDraft}
          setPlaceholderTitleDraft={setPlaceholderTitleDraft}
          handleAddPlaceholder={handleAddPlaceholder}
          editPlaceholderOpen={editPlaceholderOpen}
          setEditPlaceholderOpen={setEditPlaceholderOpen}
          editingPlaceholder={editingPlaceholder}
          setEditingPlaceholder={setEditingPlaceholder}
          handleUpdatePlaceholder={handleUpdatePlaceholder}
          replacePlaceholderOpen={replacePlaceholderOpen}
          setReplacePlaceholderOpen={setReplacePlaceholderOpen}
          setReplacingPlaceholderId={setReplacingPlaceholderId}
          replacePickerSelection={replacePickerSelection}
          setReplacePickerSelection={setReplacePickerSelection}
          replacePickerSearch={replacePickerSearch}
          setReplacePickerSearch={setReplacePickerSearch}
          availableMusic={availableMusic}
          replacingPlaceholder={replacingPlaceholder}
          handleConfirmReplacePlaceholder={handleConfirmReplacePlaceholder}
          addMusicOpen={addMusicOpen}
          setAddMusicOpen={setAddMusicOpen}
          musicPickerSelection={musicPickerSelection}
          setMusicPickerSelection={setMusicPickerSelection}
          musicPickerSearch={musicPickerSearch}
          setMusicPickerSearch={setMusicPickerSearch}
          event={event}
          addingMusic={addingMusic}
          handleAddMusic={handleAddMusic}
          reorderOpen={reorderOpen}
          setReorderOpen={setReorderOpen}
          reorderDraft={reorderDraft}
          setReorderDraft={setReorderDraft}
          reorderBusy={reorderBusy}
          savingReorder={savingReorder}
          handleSaveReorder={handleSaveReorder}
        />
      )}

      {/* iter-52b/iter-55: Invite-a-Dep dialog — mounted at page level so it works
          from both the "Can't make it?" prompt in the Attendance card AND the
          "Invite Dep" button in the Deps tab. (Previously lived inside the
          Deps TabsContent, which Radix unmounts when another tab is active.)
          Two tabs: pick an existing dep OR register a new person in one click. */}
      {/* iter-52b/iter-55: Invite-a-Dep dialog — extracted to
          EventDetail/InviteDepDialog.jsx in iter-126d (slice 5). Mounted at
          page level so it works from both the "Can't make it?" prompt in the
          Attendance card AND the "Invite Dep" button in the Deps tab.
          Two tabs: pick an existing dep OR register a new person in one click. */}
      <InviteDepDialog
        open={inviteDepOpen}
        onOpenChange={setInviteDepOpen}
        availableDeps={availableDeps}
        deps={deps}
        sections={sections}
        memberAttendance={memberAttendance}
        depInviteData={depInviteData}
        setDepInviteData={setDepInviteData}
        newDepData={newDepData}
        setNewDepData={setNewDepData}
        submittingNewDep={submittingNewDep}
        handleInviteDep={handleInviteDep}
        handleInviteNewDep={handleInviteNewDep}
      />

      {/* iter-92: notify-members-of-update + cancellation dialogs */}
      <NotifyMembersDialog
        open={notifyOpen}
        onOpenChange={setNotifyOpen}
        eventId={eventId}
        pendingChanges={event?.pending_changes || {}}
        onSent={fetchEventDetails}
      />
      <CancelEventDialog
        open={cancelOpen}
        onOpenChange={setCancelOpen}
        eventId={eventId}
        eventTitle={event?.title}
        onCancelled={fetchEventDetails}
      />

      {/* iter-116: Admin-only dep-invitation edit dialog. Extracted to
          EventDetail/EditDepInviteDialog.jsx in iter-124. */}
      <EditDepInviteDialog
        editInvite={editInvite}
        setEditInvite={setEditInvite}
        deps={deps}
        sections={sections}
        memberAttendance={memberAttendance}
        dep_invitations={dep_invitations}
        onClose={() => setEditInvite((s) => ({ ...s, open: false }))}
        onSave={handleSaveEditDepInvitation}
      />
    </div>
  );
};

export default EventDetail;
